import React from "react";
import "./App.css";
import "./Styles/main.css";
import AOS from "aos";
import "aos/dist/aos.css";

import { useEffect } from "react";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import HomeB from "./components/Container/HomeB";
import HomeLegacy from "./components/Container/Home";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import FeaturePage from "./components/Container/FeaturePageDropdown";
import AnnEffect from "./components/Container/AnnEffect";
import Resources from "./components/Container/Resources";
import ResourceDetail from "./components/Container/ResourceDetail";

import SolutionPage from "./components/Container/solutionspage";
import RoofOutline from "./components/Container/RoofOutline";
import PrivacyPolicy from "./components/Container/PrivacyPolicy";
import TermsandConditon from "./components/Container/Termsandconditions";
import ContactUs from "./components/Container/ContactUs";
import Carrers from "./components/Container/Careers";

// New marketing pages (redesign)
import FirstPrinciples from "./components/marketing/FirstPrinciples";
import FirstPrinciplesB from "./components/marketing/FirstPrinciplesB";
import SendRole from "./components/marketing/SendRole";
import WhyAnn from "./components/marketing/WhyAnn";
import HowAnnWorks from "./components/marketing/HowAnnWorks";
import HowAnnCompares from "./components/marketing/HowAnnCompares";
import PricingB from "./components/marketing/PricingB";
import PricingLegacy from "./components/marketing/Pricing";
import Trust from "./components/marketing/Trust";
import Founders from "./components/marketing/Founders";
import HeadsOfTA from "./components/marketing/HeadsOfTA";
import CHROs from "./components/marketing/CHROs";
import StaffingFirms from "./components/marketing/StaffingFirms";
import StaffingFirmsB from "./components/marketing/StaffingFirmsB";

// Scroll to top on every route change (and respect in-page hash anchors)
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route exact path="/" element={<HomeB />} />
        {/* Previous homepage, kept for side-by-side comparison */}
        <Route path="/home-legacy" element={<HomeLegacy />} />

        {/* New marketing pages */}
        <Route path="/first-principles" element={<FirstPrinciplesB />} />
        {/* Previous First Principles page, kept for side-by-side comparison */}
        <Route path="/first-principles-legacy" element={<FirstPrinciples />} />
        <Route path="/send-a-role" element={<SendRole />} />
        <Route path="/why-ann" element={<WhyAnn />} />
        <Route path="/how-it-works" element={<HowAnnWorks />} />
        <Route path="/compare" element={<HowAnnCompares />} />
        <Route path="/pricing" element={<PricingB />} />
        {/* Previous pricing page, kept for side-by-side comparison */}
        <Route path="/pricing-legacy" element={<PricingLegacy />} />
        <Route path="/trust" element={<Trust />} />
        <Route path="/for/founders" element={<Founders />} />
        <Route path="/for/heads-of-ta" element={<HeadsOfTA />} />
        <Route path="/for/chros" element={<CHROs />} />
        <Route path="/for/staffing-firms" element={<StaffingFirmsB />} />
        {/* Previous staffing-firms page, kept for side-by-side comparison */}
        <Route path="/staffing-firms-legacy" element={<StaffingFirms />} />

        {/* Existing pages (retained) */}
        <Route path="/features/:featureSlug" element={<FeaturePage />} />
        <Route path="/solutions/:featureSlug" element={<SolutionPage />} />
        <Route exact path="/ann-effect" element={<AnnEffect />} />
        <Route exact path="/resource" element={<Resources />} />
        <Route path="/resources/:id" element={<ResourceDetail />} />
        <Route path="/test" element={<RoofOutline />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-coniditon" element={<TermsandConditon />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/careers" element={<Carrers />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
